import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICastService } from '@cast/interfaces/i-cast-service';
import { ModalService } from '@common/components/modal/modal.service';
import { Relationship } from '@common/data-models/complex-types/relationship';
import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { ViewStateOptions } from '@common/data-models/navigation/viewstate-options';
import { ViewStateRecord } from '@common/data-models/records/viewstate-record';
import { ServiceResponse } from '@common/data-models/service/service-response';
import { ObjectTypes } from '@common/enums/object-types';
import { ExternalActionsService } from '@common/services/external-actions-service';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { LayoutState, ViewStateRecordsAlias } from '@common/services/layout-state';
import { NavigationService } from '@common/services/navigation-service';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { VisualStateService } from '@common/services/visual-state-service';
import { Store } from '@ngrx/store';
import { ViewStateTypes } from '@src/suite/common/enums/viewstate-types';
import { SECTIONS_SEQUENCE_FIELD } from '@src/suite/common/store/cast/cast.utils';
import { selectCurrentViewState } from '@src/suite/common/store/navigation/selectors/viewstate.selectors';
import { getPublicationExternalApiData } from '@src/suite/common/utils/record-utils';
import { PlaybookSearchService } from '@src/suite/playbook/services/playbook-search-service';
import { TopicService } from '@src/suite/playbook/services/topic-service';
import { AppService } from '@suite/app.service';
import { DataStore } from '@suite/common/data-models/data-store/data-store';
import { PublicationViewStateRecord } from '@suite/common/data-models/records/publication-viewstate-record';
import { ServiceCollectionRecord } from '@suite/common/data-models/service/service-collection-record';
import { BasicContentService } from '@suite/common/services/basic-content-service';
import { PlaybookSearchResults } from '@suite/playbook/data-models/playbook-search-results/playbook-search-results';
import moment from 'moment-timezone';

import { CastSearchService } from './cast-search-service';
import { PublicationService } from './publication-service';

@Injectable({ providedIn: 'root' })
export class CastService implements ICastService {
    // Drag & drop
    // public appendOnly: boolean = false;
    // public dragStarted: boolean = false;
    // public draggedGuid: string = null;
    // public droppedGuid: string = null;

    // public isCreatePublicationPending: boolean = false;

    // public channelSections: { [id: string]: Array<StorytellingPublicationRecord> } = {};
    // public deletedChannelSections: { [id: string]: Array<StorytellingPublicationRecord> } = {};
    // public dialogRef: MatDialogRef<StFullScreenDialogComponent, any> = null;

    // public availableRecords: Array<StorytellingRecord> = new Array<StorytellingRecord>();
    // public filteredAvailableRecords: Array<StorytellingRecord> = new Array<StorytellingRecord>();
    // public addedRecords: Set<string> = new Set<string>();

    // destroyed$: Subject<void> = new Subject<void>();
    // public _item: NavigationItem;
    // item$ = this.store
    //     .select(selectCurrentItem)
    //     .pipe(
    //         tap(item => {
    //             this._item = item ? item : null;
    //         }),
    //         takeUntil(this.destroyed$)
    //     )
    //     .subscribe();

    // protected _vs: ViewStateRecord;
    // vs$ = this.store
    //     .select(selectCurrentCastViewState)
    //     .pipe(
    //         tap(vs => {
    //             this._vs = vs ? vs : null;
    //         }),
    //         takeUntil(this.destroyed$)
    //     )
    //     .subscribe();

    constructor(
        public appService: AppService,
        public castSearchService: CastSearchService,
        public viewStateService: LayoutState,
        public visualStateService: VisualStateService,
        public languageSettings: LanguageSettings,
        public globalTablesService: GlobalTablesService,
        public nomWebServicesJson: NomWebServicesJson,
        public ngZone: NgZone,
        public navigationService: NavigationService,
        public basicContentService: BasicContentService,
        public publicationService: PublicationService,
        public modalService: ModalService,
        private externalActionsService: ExternalActionsService,
        protected dialog: MatDialog,
        private topicService: TopicService,
        private layoutState: LayoutState,
        public playbookSearchService: PlaybookSearchService,
        private store: Store
    ) {
        // CastSearchResults.castService = this;
        // this.viewStateRecordSubscription = this.viewStateService.ViewStateRecordObservable.subscribe(this.onViewStateRecordChange.bind(this));
        // his.viewStateRecordPropertySubscription = this.viewStateService.ViewStateRecordPropertyObservable.subscribe(this.onViewStateRecordPropertyChange.bind(this));
        // Clipboard.copyViewToClipboardHandlers["playbook"] = this.copyViewToClipBoard.bind(this);
        // Clipboard.renderers["playbook"] = this.copyToClipboardRenderer.bind(this);
        // this.globalTablesService.staticPropertyHandlers.PUBLICATION = this.getScheduleStaticProperties.bind(this);
        // this.globalTablesService.isPropertyForType[ObjectTypesEnum.WIRE] = this.isTopicProperty.bind(this);
        // this.globalTablesService.populateDefaultValueCallbacks[ObjectTypesEnum.WIRE] = this.populateDefaultValuesForTopic.bind(this);
        // this.globalTablesService.setFieldDefCallbacks[ObjectTypes.PUBLICATION] = this.setFieldDefsForPublications.bind(this);
        //this.globalTablesService.getGroupingOptions[ViewStateTypes.PUBLICATION] = this.getGroupingOptionsForPublications.bind(this);
        // this.globalTablesService.getSortingOptions[ViewStateTypes.PUBLICATION] = this.getSortingOptionsForSchedule.bind(this);
        //this.globalTablesService.getLayoutOptions[ViewStateTypes.PUBLICATION] = this.getLayoutOptionsForSchedule.bind(this);
        this.globalTablesService.getFiltersForViewStateType[ViewStateTypes.PUBLICATION] = this.getFiltersForPublications().bind(this);
    }

    // public viewStateGuid: string = '';

    // private _viewStatesRecords: Array<ViewStateRecord> = [];
    // public get playbookViewStateRecords(): Array<ViewStateRecord> {
    //     if (!this._viewStatesRecords || this._viewStatesRecords.length === 0) {
    //         this._viewStatesRecords = DataStore.getSingleViewStates('playbook');
    //     }
    //     return this._viewStatesRecords;
    // }

    // public async getSavedViewItems(vs?: ViewStateRecord) {
    //     this.playbookSearchResults.dispose();
    //     this.availableRecords = new Array<StorytellingRecord>();
    //     if (!vs && this._vs) {
    //         let guid = (<PublicationViewStateRecord>this._vs).viewStateGUID;
    //         if (!guid) {
    //             // Fallback to first item from dropdown
    //             guid = this.playbookViewStateRecords[0].guid;
    //         }
    //         vs = DataStore.byGuid<ViewStateRecord>(guid, '');
    //     }
    //     if (vs && this._vs) {
    //         const res = await this.playbookSearchService.getSearchResults(<ViewStateRecordsAlias>vs);
    //         if (res.status) {
    //             this.availableRecords = new Array<StorytellingRecord>();
    //             DataStore.registerSearchResults('castPlaybook', res.data);
    //             this.playbookSearchResults.rebuildGroups(
    //                 (<SingleViewStateRecord>vs).viewStateGrouping.Value,
    //                 (<SingleViewStateRecord>vs).viewStateSorting.Value,
    //                 (<SingleViewStateRecord>vs).viewStateSortOrder,
    //                 (<SingleViewStateRecord>vs).viewStateGroupSortOrder
    //             );
    //             const groupByField = (<SingleViewStateRecord>vs).viewStateGrouping.Value;
    //             if (res.data.topicGroups[groupByField]) {
    //                 for (const item of res.data.topicGroups[groupByField].keys) {
    //                     for (const rec of res.data.topicGroups[groupByField].entries[item.value]) {
    //                         if (Util.getBooleanValFromString((<PublicationViewStateRecord>this._vs).viewStateShowTopics)) {
    //                             // TODO FIX isAdded
    //                             // rec.isAdded = this.addedRecords.has(rec.Guid);
    //                             this.availableRecords.push(rec);
    //                         }
    //                         if (vs.viewStateType !== ViewStateTypes.SEARCH) {
    //                             if (Util.getBooleanValFromString((<PublicationViewStateRecord>this._vs).viewStateShowAssignments)) {
    //                                 for (const childRec of rec.children) {
    //                                     // TODO FIX isAdded
    //                                     // childRec.isAdded = this.addedRecords.has(childRec.Guid);
    //                                     this.availableRecords.push(childRec);
    //                                 }
    //                             }
    //                             if (Util.getBooleanValFromString((<PublicationViewStateRecord>this._vs).viewStateShowStories)) {
    //                                 for (const childRec of rec.children) {
    //                                     // TODO FIX isAdded
    //                                     // childRec.isAdded = this.addedRecords.has(childRec.Guid);
    //                                     this.availableRecords.push(childRec);
    //                                 }
    //                             }
    //                         }
    //                     }
    //                 }
    //             } else {
    //                 for (const topic of res.data.topics) {
    //                     if (this._vs && Util.getBooleanValFromString((<PublicationViewStateRecord>this._vs).viewStateShowTopics)) {
    //                         // TODO FIX isAdded
    //                         // topic.isAdded = this.addedRecords.has(topic.Guid);
    //                         this.availableRecords.push(topic);
    //                     }
    //                 }
    //             }

    //             if (this._vs && Util.getBooleanValFromString((<PublicationViewStateRecord>this._vs).viewStateShowAssignments)) {
    //                 for (const assignment of res.data.assignments) {
    //                     // TODO FIX isAdded
    //                     // assignment.isAdded = this.addedRecords.has(assignment.Guid);
    //                     this.availableRecords.push(assignment);
    //                 }
    //             }

    //             if (this._vs && Util.getBooleanValFromString((<PublicationViewStateRecord>this._vs).viewStateShowStories)) {
    //                 for (const story of res.data.stories) {
    //                     // TODO FIX isAdded
    //                     // assignment.isAdded = this.addedRecords.has(assignment.Guid);
    //                     this.availableRecords.push(story);
    //                 }
    //             }
    //         }
    //         this.filteredAvailableRecords = this.getFilteredAvailableRecords();
    //     }
    // }

    // public rebuildChannelSections() {
    //     // TODO FIX isAdded
    //     this.availableRecords.forEach(_rec => {
    //         // rec.isAdded = this.addedRecords.has(rec.Guid);
    //     });
    //     this.filteredAvailableRecords = this.getFilteredAvailableRecords();
    // }

    // public getFilteredAvailableRecords(): Array<StorytellingRecord> {
    //     if ((<PublicationViewStateRecord>this._vs).viewStateRemoveAddedRecords) {
    //         // TODO FIX isAdded
    //         // const res = this.availableRecords.filter(rec => !rec.isAdded);
    //         const res = [];
    //         return res;
    //     }
    //     return this.availableRecords;
    // }

    public getScheduleStaticProperties(): { [id: string]: boolean } {
        const ret: { [id: string]: boolean } = {};
        return ret;
    }

    public getSortingOptionsForSchedule(): ViewStateOptions {
        const ret: ViewStateOptions = new ViewStateOptions();
        ret.Default = PSTFieldNames.PSTChannel;
        ret.Options = [{ id: PSTFieldNames.PSTChannel, title: this.languageSettings.PSTWebGroupByChannelLabel }];
        return ret;
    }

    private _groupByPublication: Array<{ id: string; title: string }> = [];
    public get groupByPublication(): Array<{ id: string; title: string }> {
        if (this._groupByPublication.length === 0 && this.languageSettings) {
            //this._groupByPublication = this.getGroupingOptionsForPublications().Options;
        }
        return this._groupByPublication;
    }

    private _groupByPublicationKeys: Array<string> = [];
    public get groupByPublicationKeys(): Array<string> {
        if (this._groupByPublicationKeys.length === 0 && this.groupByPublication.length > 0) {
            this._groupByPublicationKeys = this.groupByPublication.map(item => item.id);
        }
        return this._groupByPublicationKeys;
    }

    /* @DELETE
    public getGroupingOptionsForPublications(): ViewStateOptions {
        const ret: ViewStateOptions = new ViewStateOptions();
        ret.Default = PSTFieldNames.PSTChannel;
        ret.Options = [{ id: PSTFieldNames.PSTChannel, title: this.languageSettings.PSTWebGroupByChannelLabel }];
        return ret;
    }

    public getLayoutOptionsForSchedule(): ViewStateOptions {
        const ret: ViewStateOptions = new ViewStateOptions();
        ret.Default = ViewStateLayouts.CONDENSE;
        ret.Options = [
            { id: ViewStateLayouts.CAST_CARD, title: this.languageSettings.PSTWebViewCardLabel },
            { id: ViewStateLayouts.CONDENSE, title: this.languageSettings.PSTWebViewCondensedLabel },
        ];
        return ret;
    }*/

    public getFiltersForPublications(): (item: FieldDef) => boolean {
        return (item: FieldDef) => {
            if (item.Briefable && item.PublicationListProp === true) {
                return true;
            }
            return false;
        };
    }

    // public setFieldDefsForPublications(fieldDef: FieldDef) {
    //     if (fieldDef.PublicationProp) {
    //         this.calculatePublicationPropComparators(fieldDef);
    //     }
    // }

    // private calculatePublicationPropComparators(prop: FieldDef) {
    //     let shouldAdd: boolean = true;
    //     switch (prop.Validation.toLowerCase()) {
    //         case 'time':
    //         case 'date': {
    //             CastSearchResults.publicationGroup2Defs[prop.ID] = new ResultGroupingDefinition(
    //                 GroupValueHelpers.DateTime(prop.ID),
    //                 GroupKeyComparatorHelpers.Value(),
    //                 RecordComparatorHelpers.DateTime(prop.ID)
    //             );
    //             break;
    //         }
    //         default:
    //             shouldAdd = false;
    //     }
    //     if (prop.GroupableProp && shouldAdd) {
    //         this.groupByPublication.push({ id: prop.ID, title: prop.DefaultCaption });
    //     }
    // }

    // public activeCollectionPollerStarted: boolean = false;

    // public get castSearchResults(): CastSearchResults {
    //     return DataStore.getSearchResults<CastSearchResults>('cast');
    // }

    // public get playbookSearchResults(): PlaybookSearchResults {
    //     return DataStore.getSearchResults<PlaybookSearchResults>('castPlaybook');
    // }

    public async loadPublicationLists(vs: ViewStateRecordsAlias, channelGuids: Array<string>) {
        const res: CastSearchResult = await this.castSearchService.getPublicationListsOfRestrictedChannelType(vs, channelGuids);
        if (res) {
            // this.castSearchResults.publicationListsOfRestrictedChannelTypes = [...res.publicationListsOfRestrictedChannelTypes];
            return new ServiceResponse<CastSearchResult>(true, res);
        } else {
            // Error
            this.nomWebServicesJson.showErrorModal({
                message: 'Unable to get Cast Publication Lists search results',
                detailMessage: 'Unable to get Cast search results. \n\rStackTrace: CastService.loadPublicationLists();',
            });
        }
        return new ServiceResponse<CastSearchResult>(false, null);
    }

    /*
    private _loadPublicationListPendingRequests: number = 0;
    public async loadPublicationList(vs: ViewStateRecordsAlias, availableRecords?: Array<StorytellingRecord>) {
        // if (!vs) vs = this._vs;
        if (!(<PublicationViewStateRecord>vs).publicationChannel) {
            return;
        }

        if ((<PublicationViewStateRecord>vs).publicationChannel.PSTPublicationChannelSchedule.toUpperCase() !== 'DAILY') {
            const modalRef = this.modalService.openAlert(
                this.languageSettings.PSTWebChannelScheduleNotSupportedLabel,
                this.languageSettings.PSTWebChannelScheduleNotSupportedDetailLabel + (<PublicationViewStateRecord>vs).publicationChannel.PSTPublicationChannelSchedule,
                'OK'
            );
            await firstValueFrom(modalRef.result);
            return new Promise<ServiceResponse<SearchResults>>(resolve => {
                resolve(new ServiceResponse<SearchResults>(false, null));
            });
        }
        if (this._loadPublicationListPendingRequests === 0) {
            if (this.navigationService.currentListView) this.navigationService.currentListView.showLoader();
        }
        this._loadPublicationListPendingRequests++;
        await this.appService.ngZone.runOutsideAngular(async () => {
            // this.appService.LoadingTopicsSource.next(true);
            // DataStore.disposeSearchResults();
            if (SearchResults.newlyAddedItems) {
                SearchResults.newlyAddedItems.dispose();
            }
            if (availableRecords) {
                for (const _rec of availableRecords) {
                    // if (rec.isCollection) {
                    //     DataStore.setCollection(<StorytellingCollectionRecord>rec, true);
                    // } else {
                    //     DataStore.set(rec);
                    // }
                }
            }
            const res: ServiceResponse<SearchResults> = await this.castSearchService.getSearchResults(vs);

            if (!this.activeCollectionPollerStarted) {
                this.activeCollectionPollerStarted = true;
                // this.startActiveCollectionPoller();
            }
            if (res.status) {
                this.castSearchResults.publicationList = null;
                DataStore.registerSearchResults('cast', res.data);
                // this.castSearchResults.rebuildGroups((<SingleViewStateRecord>vs).viewStateGrouping.Value, (<SingleViewStateRecord>vs).viewStateSorting.Value, (<PublicationViewStateRecord>vs).viewStateSortOrder, (<PublicationViewStateRecord>vs).viewStateGroupSortOrder);
            } else {
                // Error
                this.nomWebServicesJson.showErrorModal({
                    message: 'Unable to get Cast search results',
                    detailMessage: 'Unable to get Cast search results. \n\rStackTrace: CastService.loadPublicationList();',
                });
            }
            this.appService.LoadingDataSource.next(false);
            setTimeout(async () => {
                this._loadPublicationListPendingRequests--;

                if (this._loadPublicationListPendingRequests === 0) {
                    if (!this._item || !this.navigationService.isNewView(this._item)) {
                        this.navigationService.currentListView.hideLoader();
                    }
                }

                if (this._item && this.navigationService.isNewView(this._item)) {
                    this.store.dispatch(NavigationApiActions.saveCurrentNavigationItem());
                    if (this._loadPublicationListPendingRequests === 0) {
                        this.navigationService.currentListView.hideLoaderDirectly();
                    }
                }
            }, 1000);
        });
    }
        */

    // public startActiveCollectionPoller() {
    //    this.ngZone.runOutsideAngular(async () => {
    //        setInterval(async () => {
    //            if (!this.nomWebServicesJson.noSession) {
    //                let vs: ViewStateRecordsAlias = this.viewStateService.ViewStateRecord;
    //                if (vs instanceof SingleViewStateRecord) {
    //                    let res = null;
    //                    //let res = await this.discoverSearchService.getFilteredResultsGuids(vs);
    //                    if (res && res.status) {
    //                        //DataStore.getSearchResults('discover').updateNewGuids(res.data, SearchResults.newlyAddedItems.itemsGuids);
    //                    } else {
    //                        this.nomWebServicesJson.noSession = true;
    //                    }
    //                }
    //            }
    //        }, this.appService.getSolrPollInvervalInSeconds());
    //    });
    // }

    // public async deletePublication(publication: StorytellingPublicationRecord): Promise<ServiceResponse<StorytellingRecord>> {
    //     if (publication && publication.Path && publication.Guid && publication.Type) {
    //         const res: Promise<ServiceResponse<StorytellingRecord>> = this.basicContentService.deleteBasicContent(
    //             this.nomWebServicesJson.PSTServer,
    //             publication.Path.fullPath,
    //             publication.Guid,
    //             publication.Type
    //         );
    //         await this.updatePublicationListModTime(null);
    //         return res;
    //     }
    //     return new ServiceResponse<StorytellingRecord>(false, 'Unable to delete basic content: path, guid and type all need to be defined for the publication object.');
    // }

    public async updatePublicationRecords(
        event: { sourceSection: string; targetSection: string; sourceIndex: number; targetIndex: number },
        channelSections: StorytellingPublicationListSections,
        publicationList: Pick<StorytellingCollectionRecord, 'Path' | 'Guid'>
    ) {
        let guidsFrom = [];
        let guidsTo = [];

        const toSectionIndex = event.targetIndex;

        if (event.sourceSection === event.targetSection) {
            if (event.sourceIndex > event.targetIndex) {
                guidsTo = channelSections[event.targetSection].slice(event.targetIndex, event.sourceIndex + 1);
            } else {
                guidsTo = channelSections[event.targetSection].slice(event.sourceIndex, event.targetIndex + 1);
            }
        } else {
            guidsFrom = channelSections[event.targetSection].slice(event.sourceIndex);
            guidsTo = channelSections[event.targetSection].slice(event.sourceIndex);
        }
        const requestParams = {
            action: 'sort',
            database: this.nomWebServicesJson.getDatabase(),
            fromSectionName: event.sourceSection,
            fromSectionIndex: event.sourceIndex,
            fromRecordsToUpdateGuids: guidsFrom,
            toSectionName: event.targetSection,
            toSectionIndex,
            toRecordsToUpdateGuids: guidsTo,
            collectionPath: publicationList.Path.fullPath,
            collectionGuid: publicationList.Guid,
        };
        try {
            await this.nomWebServicesJson.patch('/api/Publication', JSON.stringify(requestParams), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                responseType: 'json',
                observe: 'response',
            });
            await this.updatePublicationListModTime(publicationList);
            return new ServiceResponse<StorytellingPublicationRecord>(true, null);
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: 'Unable to create publication',
                detailMessage: `Unable to update publication. \n\rStackTrace: CastService.updatePublicationRecords(); \n\rError: ${error}`,
            });
            return new ServiceResponse<StorytellingPublicationRecord>(false, `Unable to update publication ${error.toString()}`);
        }
    }

    public async updatePublicationListSequence(
        sequence: Array<string>,
        sections: StorytellingPublicationListSections,
        publicationList: Pick<StorytellingCollectionRecord, 'Path' | 'Guid'>
    ): Promise<ServiceResponse<StorytellingPublicationRecord>> {
        const database: string = this.nomWebServicesJson.getDatabase();
        const path: string = publicationList.Path.fullPath;
        // const collection: { [section: string]: Array<string> } = {};

        // for (const key of sequence) {
        //     const pubs = sections[key];
        //     collection[key] = (pubs || []).filter(pub => !!pub);
        // }

        const data = {
            PublicationSequenceCollection: JSON.stringify(sections),
            Type: ObjectTypes.PUBLICATIONLIST,
        };

        const res = await this.basicContentService.updateBasicContentV2<StorytellingPublicationListRecord>(database, path, publicationList.Guid, false, data, false, null);
        if (res.status) {
            for (const section in sections) {
                if (section === SECTIONS_SEQUENCE_FIELD) {
                    continue;
                }
                const guids: Array<string> = sections[section];
                if (guids.length > 0) {
                    const requestParams = {
                        action: 'update',
                        database: this.nomWebServicesJson.getDatabase(),
                        toSectionName: section,
                        toSectionIndex: -1,
                        collectionPath: publicationList.Path.fullPath,
                        collectionGuid: publicationList.Guid,
                        toRecordsToUpdateGuids: guids,
                    };
                    try {
                        await this.nomWebServicesJson.patch('/api/Publication', JSON.stringify(requestParams), {
                            headers: new HttpHeaders({
                                'Content-Type': 'application/json',
                                'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                            }),
                            responseType: 'json',
                            observe: 'response',
                        });
                    } catch (error) {
                        this.nomWebServicesJson.showErrorModal({
                            message: 'Unable to update publication',
                            detailMessage: `Unable to update publication. \n\rStackTrace: CastService.createPublications(); \n\rError: ${error}`,
                        });
                    }
                }
            }
        }
        return res;
    }

    public async createPublicationList(
        vs: ViewStateRecord,
        sections: Array<string>,
        channelSections?: { [id: string]: Array<StorytellingPublicationRecord> }
    ): Promise<ServiceResponse<StorytellingPublicationListRecord>> {
        let response: HttpResponse<any> = null;
        const database: string = this.nomWebServicesJson.getDatabase();
        const path: string = `P_${this.nomWebServicesJson.PSTGroup}\\W\\${this.nomWebServicesJson.PSTHoldFolder}`;
        const fields: { [id: string]: any } = {};
        const date = (<PublicationViewStateRecord>vs).publicationTime.get();

        fields.Type = ObjectTypes.PUBLICATIONLIST;

        const listTitle = (<PublicationViewStateRecord>vs).publicationListTitle ? (<PublicationViewStateRecord>vs).publicationListTitle : (<PublicationViewStateRecord>vs).title;
        fields.Title = `${listTitle}-${(<PublicationViewStateRecord>vs).publicationTime.moment.format('YYYY-MM-DD')}-Revision${(<PublicationViewStateRecord>vs).publicationRevisionNumber + 1}`;
        fields.PSTPublicationChannelGUID = (<PublicationViewStateRecord>vs).publicationChannelGUID;
        fields.PSTPublicationListTitle = (<PublicationViewStateRecord>vs).publicationListTitle;
        fields.PSTPublicationListRevisionNumber = (<PublicationViewStateRecord>vs).publicationRevisionNumber;
        // if (fields.PSTPublicationListRevisionNumber < 0) {
        //     fields.PSTPublicationListRevisionNumber = 0;
        // }
        this.castSearchService.calculateNgTimeOffset(date);
        const vsPublicationTime = `${moment(date).format('YYYY-MM-DDTHH:mm:00.000')}Z`;
        fields.PSTPublicationListTime = vsPublicationTime;
        fields.PSTPublicationEditionName = (<PublicationViewStateRecord>vs).editionName;

        if (sections) {
            const sequence: { [section: string]: Array<string> } = {};
            for (const key of sections) {
                const pubs = channelSections[key];
                const guids: Array<string> = new Array<string>();
                if (pubs) {
                    for (let i = 0; i < pubs.length; i++) {
                        if (pubs[i] && pubs[i].Guid) {
                            guids.push(pubs[i].Guid);
                        }
                    }
                }
                sequence[key] = guids;
            }
            const sectionsSequence = {
                [SECTIONS_SEQUENCE_FIELD]: sections,
            };

            fields.PublicationSequenceCollection = JSON.stringify({ ...sequence, ...sectionsSequence });
        }

        try {
            const requestParams = {
                database,
                path,
                dateTime: '',
                user: this.nomWebServicesJson.UserId,
                fieldsToUpdate: this.nomWebServicesJson.convertor.toENPSFields(fields),
            };
            response = await this.nomWebServicesJson.put('/api/Publication', JSON.stringify(requestParams), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                responseType: 'json',
                observe: 'response',
            });
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: 'Unable to create publication list',
                detailMessage: `Unable to create publicationList. \n\rStackTrace: CastService.createPublicationList(); \n\rError: ${error}`,
            });
            return new ServiceResponse<StorytellingPublicationListRecord>(false, `Unable to create publication list ${error.toString()}`);
        }
        const serviceRecord = ServiceCollectionRecord.instance(response.body);
        serviceRecord.instantiateChildren();

        const publicationListRecord = this.nomWebServicesJson.convertor.fromServiceCollectionRecordV2<StorytellingPublicationListRecord>(serviceRecord);
        // await DataStore.setCollection(publicationListRecord, true);

        // vsPublicationTime = `${moment((<PublicationViewStateRecord>vs).publicationTime.get()).format('YYYY-MM-DDTHH:mm:00.000')}Z`;
        // const publicationTime = `${moment(publicationListRecord.PSTPublicationListTime.get()).format('YYYY-MM-DDTHH:mm:00.000')}Z`;
        // if (vsPublicationTime === publicationTime) {
        //     this.castSearchResults.publicationList = publicationListRecord;
        // }

        return new ServiceResponse<StorytellingPublicationListRecord>(true, publicationListRecord);
    }

    /*
    public async createPublication(publication: StorytellingPublicationRecord, section: string, index: number): Promise<ServiceResponse<StorytellingPublicationRecord>> {
        publication.Owner = this.nomWebServicesJson.UserId;
        if (!publication.Relationships) {
            publication.Relationships = new Relationship();
        }
        publication.Relationships.setGuid(publication.linkedRecords?.[0].Guid, 0);
        publication.Relationships.setType('PUBLICATION', 0);
        const fields: any = this.nomWebServicesJson.convertor.serialize(publication);
        const requestParams = {
            database: this.nomWebServicesJson.getDatabase(),
            sectionName: section,
            sectionIndex: index,
            collectionPath: this.castSearchResults.publicationList.Path.fullPath,
            collectionGuid: this.castSearchResults.publicationList.Guid,
            fieldsToUpdate: this.nomWebServicesJson.convertor.toENPSFields(fields),
        };
        let response: HttpResponse<any> = null;
        try {
            response = await this.nomWebServicesJson.patch('/api/Publication', JSON.stringify(requestParams), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                responseType: 'json',
                observe: 'response',
            });
            await this.updatePublicationListModTime();
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: 'Unable to create publication',
                detailMessage: `Unable to create publication. \n\rStackTrace: CastService.createPublication(); \n\rError: ${error}`,
            });
            return new ServiceResponse<StorytellingPublicationRecord>(false, `Unable to create publication ${error.toString()}`);
        }
        const record: StorytellingRecord = null;
        if (response.body['Stories']) {
            const objectProperties = new ObjectProperties(response.body.Stories[0]);
            // record = RecordFactory.createRecordForType(fields.Type);
            this.nomWebServicesJson.convertor.deserializeV2(record, objectProperties);
            // await DataStore.set(record);
        }
        if (response.status) {
            return new Promise<ServiceResponse<StorytellingPublicationRecord>>(resolve => {
                resolve(new ServiceResponse<StorytellingPublicationRecord>(true, publication));
            });
        }
        return new Promise<ServiceResponse<StorytellingPublicationRecord>>(resolve => {
            resolve(new ServiceResponse<StorytellingPublicationRecord>(false, publication));
        });
    }
    */

    /*
    public async deletePublicationRecordsOld(
        publicationsProps: Array<{ publicationList: StorytellingPublicationListRecord; section: string; index: number; channelSections: { [id: string]: Array<StorytellingPublicationRecord> } }>
    ): Promise<ServiceResponse<boolean>> {
        const publicationsRequestParams = [];
        for (const publicationProp of publicationsProps) {
            const publicationRecordsGuids = publicationProp.channelSections ? publicationProp.channelSections[publicationProp.section].map(rec => rec.Guid).splice(publicationProp.index + 1) : [];
            const params = {
                index: publicationProp.index,
                database: publicationProp.publicationList.Database,
                collectionPath: publicationProp.publicationList.Path.fullPath,
                collectionGuid: publicationProp.publicationList.Guid,
                publicationGuid: publicationProp.channelSections ? publicationProp.channelSections[publicationProp.section][publicationProp.index].Guid : '',
                publicationRecordsGuids,
                fieldsToUpdate: [],
            };
            publicationsRequestParams.push(params);
        }
        const requestParams = {
            publications: publicationsRequestParams,
        };
        try {
            await this.nomWebServicesJson.delete('/api/Publication', {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                responseType: 'json',
                body: JSON.stringify(requestParams),
                observe: 'response',
            });
            for (const publicationProp of publicationsProps) {
                await this.updatePublicationListModTime(publicationProp.publicationList);
            }
            return new ServiceResponse<boolean>(true);
        } catch (error) {
            const msg = 'Unable to delete publication.';
            this.nomWebServicesJson.showErrorModal({
                message: `${msg}`,
                detailMessage: `${msg} \n\rStackTrace: CastService.deletePublicationRecords(); \n\rError: ${error}`,
            });
            return new ServiceResponse<boolean>(false, msg + error.toString());
        }
    }
    */

    public async deletePublicationRecords(
        publicationsProps: Array<{ publicationList: StorytellingPublicationListRecord; section: string; index: number; channelSections: StorytellingPublicationListSections }>
    ): Promise<ServiceResponse<boolean>> {
        const publicationsRequestParams = [];
        for (const publicationProp of publicationsProps) {
            const publicationRecordsGuids = publicationProp.channelSections ? publicationProp.channelSections[publicationProp.section].splice(publicationProp.index + 1) : [];
            const params = {
                index: publicationProp.index,
                database: publicationProp.publicationList.Database,
                collectionPath: publicationProp.publicationList.Path.fullPath,
                collectionGuid: publicationProp.publicationList.Guid,
                publicationGuid: publicationProp.channelSections ? publicationProp.channelSections[publicationProp.section][publicationProp.index] : '',
                publicationRecordsGuids,
                fieldsToUpdate: [],
            };
            publicationsRequestParams.push(params);
        }
        const requestParams = {
            publications: publicationsRequestParams,
        };
        try {
            await this.nomWebServicesJson.delete('/api/Publication', {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                responseType: 'json',
                body: JSON.stringify(requestParams),
                observe: 'response',
            });
            for (const publicationProp of publicationsProps) {
                await this.updatePublicationListModTime(publicationProp.publicationList);
            }
            return new ServiceResponse<boolean>(true);
        } catch (error) {
            const msg = 'Unable to delete publication.';
            this.nomWebServicesJson.showErrorModal({
                message: `${msg}`,
                detailMessage: `${msg} \n\rStackTrace: CastService.deletePublicationRecords(); \n\rError: ${error}`,
            });
            return new ServiceResponse<boolean>(false, msg + error.toString());
        }
    }

    public async createPublications(
        publications: Array<StorytellingPublicationRecord>,
        section: string,
        index: number,
        guids: Array<string>,
        publicationList: StorytellingPublicationListRecord
    ): Promise<ServiceResponse<Array<StorytellingPublicationRecord>>> {
        const fields = [];
        let type: number = null;
        for (let i = 0; i < publications.length; i++) {
            publications[i].Owner = this.nomWebServicesJson.UserId;
            if (!publications[i].Relationships) {
                publications[i].Relationships = new Relationship();
            }
            publications[i].Relationships.setGuid(publications[i].linkedRecords?.[0].Guid, 0);
            publications[i].Relationships.setType('PUBLICATION', 0);
            delete publications[i].linkedRecords;
            const publicationFields: any = this.nomWebServicesJson.convertor.serialize(publications[i]);
            if (!type) {
                type = publicationFields.Type;
            }
            fields.push(this.nomWebServicesJson.convertor.toENPSFields(publicationFields));
        }

        // const publicationList: StorytellingPublicationListRecord = DataStore.byGuid<StorytellingPublicationListRecord>(publicationListGuid, '');
        // TODO: Fix this
        // const publicationList: StorytellingPublicationListRecord = null;

        if (!publicationList?.Guid || !publicationList?.Path?.fullPath) {
            return new Promise<ServiceResponse<Array<StorytellingPublicationRecord>>>(resolve => {
                resolve(new ServiceResponse<Array<StorytellingPublicationRecord>>(false, publications));
            });
        }

        const requestParams = {
            action: 'add',
            database: this.nomWebServicesJson.getDatabase(),
            toSectionName: section,
            toSectionIndex: index,
            collectionPath: publicationList?.Path?.fullPath,
            collectionGuid: publicationList?.Guid,
            fieldsToUpdateCollection: fields,
            toRecordsToUpdateGuids: guids,
        };

        let response: HttpResponse<any> = null;
        try {
            response = await this.nomWebServicesJson.patch('/api/Publication', JSON.stringify(requestParams), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                responseType: 'json',
                observe: 'response',
            });
            await this.updatePublicationListModTime(publicationList);
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: 'Unable to create publication',
                detailMessage: `Unable to create publication. \n\rStackTrace: CastService.createPublications(); \n\rError: ${error}`,
            });
            return new ServiceResponse<Array<StorytellingPublicationRecord>>(false, `Unable to create publication ${error.toString()}`);
        }

        if (response.status) {
            return new Promise<ServiceResponse<Array<StorytellingPublicationRecord>>>(resolve => {
                resolve(new ServiceResponse<Array<StorytellingPublicationRecord>>(true, publications));
            });
        }
        return new Promise<ServiceResponse<Array<StorytellingPublicationRecord>>>(resolve => {
            resolve(new ServiceResponse<Array<StorytellingPublicationRecord>>(false, publications));
        });
    }

    public async publishPublicationList(
        oldRecord: StorytellingPublicationListRecord & { PSTPublicationChannelName?: string },
        actionId: string,
        channelSections: { [id: string]: Array<StorytellingPublicationRecord> }
    ): Promise<StorytellingPublicationListRecord> {
        const { Database } = oldRecord;
        const { fullPath } = oldRecord.Path;
        const { Guid } = oldRecord;

        const vs = this.store.selectSignal(selectCurrentViewState)() as PublicationViewStateRecord;
        oldRecord.Title = vs.publicationChannel.Title;
        oldRecord.PSTPublicationChannelName = vs.publicationChannel.Title;
        const extActionData = getPublicationExternalApiData(actionId, this.nomWebServicesJson.UserId, oldRecord, channelSections);
        const extRes: ServiceResponse<ExternalActionResponse> = await this.externalActionsService.postExternalAction(extActionData);

        if (extRes.status) {
            if (!extRes.data || !extRes.data.status || extRes.data.status >= 300 || extRes.data.status < 200) {
                this.nomWebServicesJson.showErrorModal({
                    message: 'Unable to publish publication list',
                    detailMessage: 'Unable to publish publication list. \n\rStackTrace: CastService.publishPublicationList();',
                });
                return null;
            }

            const updateArgs = {
                PSTPublicationListPublishedTime: moment(extActionData.timestamp).toISOString(),
                PSTPublicationListPublishedBy: this.nomWebServicesJson.UserId,
                Type: oldRecord.Type,
            };
            const updateRes = await this.basicContentService.updateBasicContentV2<StorytellingPublicationListRecord>(Database, fullPath, Guid, false, updateArgs, false, null);
            if (updateRes.data) {
                return updateRes.data;
            }
        }
        return null;
    }

    public async newRevision(oldRecord: StorytellingPublicationListRecord): Promise<ServiceResponse<StorytellingPublicationListRecord>> {
        const { Database } = oldRecord;
        const { fullPath } = oldRecord.Path;
        const { groupId } = oldRecord.Path;
        const { Guid } = oldRecord;
        const fields = {
            PSTPublicationListPublishedTime: '',
            Title: '',
        };
        const vs = this.store.selectSignal(selectCurrentViewState)() as PublicationViewStateRecord;
        if (vs) {
            const listTitle = vs.publicationListTitle ? vs.publicationListTitle : vs.title;
            const title = `${listTitle}-${vs.publicationTime.moment.format('YYYY-MM-DD')}-Revision${vs.publicationRevisionNumber + 2}`;
            fields.Title = title;
        }
        const res = await this.publicationService.publishPublicationList(Database, fullPath, Guid, groupId, true, fields);
        return res;
    }

    public async updatePublicationListModTime(publicationList: StorytellingPublicationListRecord): Promise<ServiceResponse<StorytellingPublicationListRecord>> {
        if (!publicationList) {
            return new ServiceResponse<StorytellingPublicationListRecord>(false, 'Unable to update publication list mod time: publication list is not defined.');
        }
        const database: string = this.nomWebServicesJson.getDatabase();
        const modTime = moment(new Date()).utc();
        const data = {
            ModTime: modTime,
            Type: ObjectTypes.PUBLICATIONLIST,
        };
        return this.basicContentService.updateBasicContentV2<StorytellingPublicationListRecord>(database, publicationList.Path.fullPath, publicationList.Guid, false, data, false, null);
    }
}

DataStore.registerSearchResults('castPlaybook', new PlaybookSearchResults());
